import { useMemo } from 'react';
import LeftColumnComp from 'developer-docs-shared-components/components/endpoint/LeftColumnComp';
import { jsx as _jsx } from "react/jsx-runtime";
const EndpointLeftColumn = ({
  children
}) => {
  const columnSpan = useMemo(() => ({
    base: 12,
    laptop: 6
  }), []);
  return /*#__PURE__*/_jsx(LeftColumnComp, {
    columnSpan: columnSpan,
    children: children
  });
};
export default EndpointLeftColumn;